export default __webpack_public_path__ + "ring-plus.dc9fa7a4a1282771.svg";